import Box from '@mui/material/Box'
import Skeleton from '@mui/material/Skeleton'

/** Layout-shaped skeleton for Companies landing (Lovable card grid). */
export function CompaniesLandingSkeleton() {
  return (
    <Box data-testid="companies-landing-skeleton" aria-busy aria-label="Loading companies">
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
          gap: 2,
          flexWrap: 'wrap',
          mb: 3,
        }}
      >
        <Box>
          <Skeleton variant="text" width={180} height={36} sx={{ mb: 0.5 }} />
          <Skeleton variant="text" width={360} height={22} />
        </Box>
        <Skeleton variant="rounded" width={180} height={40} sx={{ borderRadius: '8px' }} />
      </Box>
      <Box sx={{ display: 'flex', gap: 2, mb: 4, flexWrap: 'wrap' }}>
        <Skeleton variant="rounded" width={420} height={42} sx={{ borderRadius: '10px' }} />
        <Skeleton variant="rounded" width={180} height={42} sx={{ borderRadius: '10px' }} />
      </Box>
      <Box
        sx={{
          display: 'grid',
          gap: 3,
          gridTemplateColumns: {
            xs: '1fr',
            sm: 'repeat(2, minmax(0, 1fr))',
            xl: 'repeat(3, minmax(0, 1fr))',
          },
        }}
      >
        {['a', 'b', 'c', 'd', 'e', 'f'].map((slot) => (
          <Skeleton key={slot} variant="rounded" height={360} sx={{ borderRadius: '16px' }} />
        ))}
      </Box>
    </Box>
  )
}

/** Skeleton for Lovable company detail (profile card + campaigns). */
export function CompanyDetailSkeleton() {
  return (
    <Box
      data-testid="company-detail-skeleton"
      aria-busy
      aria-label="Loading company"
      sx={{ mx: 'auto', width: '100%', maxWidth: 1200 }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: 2, mb: 3, flexWrap: 'wrap' }}>
        <Skeleton variant="text" width={280} height={28} />
        <Skeleton variant="rounded" width={180} height={44} sx={{ borderRadius: '12px' }} />
      </Box>
      <Skeleton variant="rounded" height={280} sx={{ borderRadius: '16px', mb: 4 }} />
      <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: 2, mb: 3, flexWrap: 'wrap' }}>
        <Box>
          <Skeleton variant="text" width={200} height={32} />
          <Skeleton variant="text" width={260} height={20} />
        </Box>
        <Box sx={{ display: 'flex', gap: 1.5 }}>
          <Skeleton variant="rounded" width={220} height={42} sx={{ borderRadius: '10px' }} />
          <Skeleton variant="rounded" width={160} height={42} sx={{ borderRadius: '10px' }} />
        </Box>
      </Box>
      <Box
        sx={{
          display: 'grid',
          gap: 3,
          gridTemplateColumns: { xs: '1fr', md: 'repeat(2, 1fr)', xl: 'repeat(3, 1fr)' },
        }}
      >
        {['a', 'b', 'c'].map((slot) => (
          <Skeleton key={slot} variant="rounded" height={300} sx={{ borderRadius: '16px' }} />
        ))}
      </Box>
    </Box>
  )
}
